import { toast, type ToastOptions } from "react-hot-toast"

import "./styles.scss"

const success = (message?: string, options?: ToastOptions) => {
  toast.success(
    () => (
      <div onClick={() => toast.dismiss()}>{message || "Muvaffaqiyatli amalga oshirildi!"}</div>
    ),
    {
      icon: (
        <div className="toast-success" onClick={() => toast.dismiss()}>
          {" "}
        </div>
      ),
      ...options,
    },
  )
}

const error = (message?: string, options?: ToastOptions) => {
  toast.error(() => <div onClick={() => toast.dismiss()}>{message || "Serverda xatolik"}</div>, {
    icon: (
      <div className="toast-error" onClick={() => toast.dismiss()}>
        {" "}
      </div>
    ),
    ...options,
  })
}

const notification = {
  success,
  error,
}

export default notification
